<template>
    <el-dialog :title="isAdd ? '新增组件' : '编辑组件' " :visible.sync="dialogVisible" width="1000px" append-to-body :before-close="resetForm">
        <el-form :model="form" :rules="rules" ref="form" label-width="120px">
            <el-form-item label="组件名称" prop="name">
                <el-input v-model="form.name" placeholder="请输入组件名称" maxlength="20"></el-input>
            </el-form-item>
            <el-form-item label="组件位置">
                <el-select v-model="form.position" style="width: 170px">
                    <el-option v-for="item in positionData" :key="item.key" :label="item.value" :value="item.key"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="组件样式" prop="style">
				<el-radio-group v-model="form.style" @change="changeType">
					<el-radio :label="1">一行一</el-radio>
					<el-radio :label="2">二列三</el-radio>
					<el-radio :label="3">一行三</el-radio>
				</el-radio-group>
            </el-form-item>
            <div class="detailList">
                <div class="detailListItem" v-for="(item, index) in form.detailList" :key="'detailList' + index">
                    <el-form-item label="组件图片" :prop="'detailList.' + index + '.imgUrl'" :rules="[{ required: true, message: '请上传组件图片', trigger: 'blur' }]">
                        <el-upload class="upload-demo" :show-file-list="false" :action="uploadAction" :on-success="val => uploadSuccessHandler(val, 'imgUrl', index)" :headers="uploadHeaders">
                            <el-button size="small" type="primary">上传图片</el-button>
                        </el-upload>
                        <div class="upload-text">请上传比例是{{setCc(form.style, index)}}的图，格式不限</div>
                        <img :src="item.imgUrl" v-if="item.imgUrl" class="upload-image" />
                    </el-form-item>
                    <el-form-item label="跳转类型">
                        <el-select v-model="item.linkType" style="width: 170px">
                            <el-option v-for="i in typeData" :key="i.key" :label="i.value" :value="i.key"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="跳转目标" v-if="item.linkType == 1" :prop="'detailList.' + index + '.wechatPath'" :rules="[{ required: true, message: '请输入跳转目标', trigger: 'blur' }]">
                        <el-input v-model="item.wechatPath" placeholder="请输入地址"></el-input>
                    </el-form-item>
                    <el-form-item label="跳转图片" v-if="item.linkType == 2" :prop="'detailList.' + index + '.linkImgUrl'" :rules="[{ required: true, message: '请上传跳转图片', trigger: 'blur' }]">
                        <el-upload class="upload-demo" :show-file-list="false" :action="uploadAction" :on-success="val => uploadSuccessHandler(val, 'linkImgUrl', index)" :headers="uploadHeaders">
                            <el-button size="small" type="primary">上传图片</el-button>
                        </el-upload>
                        <div class="upload-text">请上传图片，用户可在小程序端查看该图片</div>
                        <img :src="item.linkImgUrl" v-if="item.linkImgUrl" class="upload-image" />
                    </el-form-item>
                    <el-form-item label="小程序AppID" v-if="item.linkType == 3" :prop="'detailList.' + index + '.wechatId'" :rules="[{ required: true, message: '请输入小程序AppID', trigger: 'blur' }]">
                        <el-input v-model="item.wechatId" placeholder="请输入小程序AppID"></el-input>
                    </el-form-item>
                    <el-form-item label="path地址" v-if="item.linkType == 3" :prop="'detailList.' + index + '.wechatPath'" :rules="[{ required: true, message: '请输入path地址', trigger: 'blur' }]">
                        <el-input v-model="item.wechatPath" placeholder="请输入path地址"></el-input>
                    </el-form-item>
                    <el-form-item label="文本内容" v-if="item.linkType == 4" :prop="'detailList.' + index + '.linkText'" :rules="[{ required: true, message: '请输入文本内容，若是口令，暂时只支持淘宝渠道', trigger: 'blur' }]">
                        <tinymce-editor ref="tiny" :id="`tinymce${index}`" v-model="item.linkText" :isPlugins="true"></tinymce-editor>
                    </el-form-item>
                    <el-form-item label="视频号ID" v-if="item.linkType == 5" :prop="'detailList.' + index + '.videoId'" :rules="[{ required: true, message: '请输入path地址', trigger: 'blur' }]">
                        <el-input v-model="item.videoId" placeholder="请输入视频号ID"></el-input>
                    </el-form-item>
                </div>
            </div>
            <el-form-item label="显示隐藏" prop="status">
                <el-switch v-model="form.status" active-color="#409EFF" inactive-color="#ddd" :active-value="1" :inactive-value="0"></el-switch>
            </el-form-item>
            <el-form-item label="排序权重" prop="sort">
                <el-input v-model="form.sort" type="number" placeholder="数字越大，排序越前" maxlength="4"></el-input>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button @click="resetForm">取 消</el-button>
            <el-button type="primary" @click="confirmHandle">确 定</el-button>
        </span>
    </el-dialog>
</template>

<script>
import { prefix } from '@/api';
import { storage } from '@/utils';
import { authToken } from '@/config';
import resourcesService from '@/services/operate/resources'
import TinymceEditor from '@/components/tinymce/onPlugins.vue';
export default {
    components: { TinymceEditor },
    data() {
        return {
            dialogVisible: false,
            uploadAction: `${prefix}/admin/operation/brand/upload_logo`,
            uploadHeaders: {
                token: storage.getItem(authToken),
            },
            form: {
                name: '',
                describe: '',
                position: 1,
                status: 1,
                style: 1,
                sort: '',
                detailList: [{
                    linkType: 1,
                    imgUrl: '',
                    wechatId: '',
                    wechatPath: '',
                    linkImgUrl: '',
                    linkText: '',
                    videoId: ''
                }],
            },
            itemData: {
                linkType: 1,
                imgUrl: '',
                wechatId: '',
                wechatPath: '',
                linkImgUrl: '',
                linkText: '',
                videoId: ''
            },
            brandId: null,
            positionData: [
                {
                    key: 1,
                    value: '发现首页'
                }
            ],
            typeData: [
                {
                    key: 1,
                    value: '地址'
                }, {
                    key: 2,
                    value: '图片'
                }, {
                    key: 3,
                    value: '小程序'
                }, {
                    key: 4,
                    value: '文本'
                }, {
                    key: 5,
                    value: '视频号主页'
                }
            ],
            rules: {
                name: [{ required: true, message: '请输入组件名称', trigger: 'blur' }],
                sort: [{ required: true, message: '请输入排序权重', trigger: 'blur' }]
            },
            isAdd: true,
        }
    },
    methods: {
        addHanle() {
            this.dialogVisible = true
            this.isAdd = true
        },
        editHanle(data) {
            this.dialogVisible = true;
            this.isAdd = false;
            const { id, name, style, describe, position, status, sort, detailList } = data;
            this.brandId = id;
            this.form = {
                id, name, describe, position, status, sort, style,
                detailList,
            }
        },
        uploadSuccessHandler(esponse, name, index) {
            const { code, result } = esponse;
            let d = JSON.parse(JSON.stringify(this.form.detailList))
            if (Object.is(code, 0)) {
                d[index][name] = result.url
                this.$set(this.form, 'detailList', d)
            } else {
                this.$message.error('上传失败');
                this.form.detailList[index][name] = '';
            }
        },
        resetForm() {
            this.dialogVisible = false;
            this.$emit('close')
        },
        confirmHandle() {
            this.$refs['form'].validate((valid) => {
                if (!valid) return false;
                const { name, describe, position, status, sort, style, detailList } = this.form
                let data = {
                    name, describe, position, status, style,
                    sort: Number(sort),
                    componentsList: detailList
                }
                this.isAdd ? this.add(data) : this.edit(data)
            })
        },
        add(data) {
            resourcesService.addResources(data).then(res => {
                this.success(res)
            })
        },
        edit(data) {
            resourcesService.editResources(this.brandId, data).then(res => {
                this.success(res)
            })
        },
        success(res) {
            if (res.code == 0) {
                this.$message.success(this.isAdd ? '新增成功' : '编辑成功')
                this.$emit('success')
            } else {
                this.$message.error(res.message)
            }
        },
        changeType(v) {
            console.log(v)
            let d = JSON.parse(JSON.stringify(this.itemData))
            if(v == 1) {
                this.form.detailList = [d]
            } else {
                this.form.detailList = [
                    {
                        linkType: 1,
                        imgUrl: '',
                        wechatId: '',
                        wechatPath: '',
                        linkImgUrl: '',
                        linkText: '',
                        videoId: ''
                    }, {
                        linkType: 1,
                        imgUrl: '',
                        wechatId: '',
                        wechatPath: '',
                        linkImgUrl: '',
                        linkText: '',
                        videoId: ''
                    }, {
                        linkType: 1,
                        imgUrl: '',
                        wechatId: '',
                        wechatPath: '',
                        linkImgUrl: '',
                        linkText: '',
                        videoId: ''
                    }
                ]
            }
        },
        setCc(t, i) {
            if (t == 1) {
                return '686*176'
            } else if (t == 3) {
                return '1:1'
            } else if (t == 2) {
                let t = ['336*368', '336*176', '336*176']
                return t[i]
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.upload-text {
  font-size: 15px;
  margin-top: 5px;
}
.upload-image{
    width: 100px;
    height: 100px;
}
.detailListItem{
    background-color: #ccc;
    background-color: #eee;
    padding: 20px;
    margin-bottom: 20px;
    border-radius: 5px;
}
::v-deep .el-dialog__body{
    max-height: 500px;
    overflow-y: auto;
}
</style>
